var map = {
	"./color-1.png": 324,
	"./color-10.png": 514,
	"./color-11.png": 515,
	"./color-12.png": 516,
	"./color-13.png": 517,
	"./color-14.png": 518,
	"./color-2.png": 519,
	"./color-3.png": 520,
	"./color-4.png": 521,
	"./color-5.png": 522,
	"./color-6.png": 523,
	"./color-7.png": 524,
	"./color-8.png": 525,
	"./color-9.png": 526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;